/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { ContentfulProvider } from './ContentfulContext';

export const withContentfulWrapper = (WrappedComponent, opts = {}) => {
  class ContentfulWrapper extends Component {

    state = {}

    render() {
      return (
        <ContentfulProvider>
          <WrappedComponent {...this.props} />
        </ContentfulProvider>
      );
    }
  }

  ContentfulWrapper.displayName = WrappedComponent.displayName || 'ContentfulWrapper';

  if (WrappedComponent?.dataModel) {
    ContentfulWrapper.dataModel = WrappedComponent.dataModel;
  }

  return ContentfulWrapper;
};
